//router
// import IndexRouters from "./router/index"
import {useEffect} from 'react'

//scss
import "./assets/scss/hope-ui.scss"
import "./assets/scss/custom.scss"
import "./assets/scss/dark.scss"
import "./assets/scss/rtl.scss"
import "./assets/scss/customizer.scss"

// Redux Selector / Action
import { useDispatch } from 'react-redux';

// import state selectors
import { setSetting } from './store/setting/actions'
import { useLoader } from './components/loader/LoaderContext'; // Importa il contesto del Loader
import Loader from './components/loader/Loader'; // Importa il componente del loader

function App({children}) {
  const dispatch = useDispatch();
  const { loading, loaderType  } = useLoader(); // Usa lo stato globale del loader

  useEffect(() => {
    // setState here is safe
    dispatch(setSetting());
  }, []);

  return (
      <div className="App">
        {loading && <Loader type={loaderType} />} {/* Mostra il loader quando loading è true */}
        {/* <IndexRouters /> */}
        {children}
      </div>
  );
}

export default App;
